// From Templates
import {load} from '@shopify/theme-sections';

import './index';
import './article';
import './blog';
import './tutorials';
import './cart';
import './collection';
import './gift_card';
import './page.about';
import './page.help';
import './product';
import './search';

import './customers/login';
import './customers/register';
import './customers/account.info';
import './customers/addresses';

load('*');
